module.exports = __webpack_public_path__ + "static/sixth_user_image2-03a1188636e63a5f6228aa079f610713.jpg";